module.exports = __webpack_public_path__ + "media/application/images/external-services/etsy-logo-cd40bc3a74382fd66a7905a4d3fe8b89.svg";